import {
  inventoryDashboardPath,
  inventoryCreateItemPath,
  inventoryCreatePackagePath,
  inventoryEditItemPath,
  inventoryEditPackagePath,
  inventoryViewPackagePath,
  inventoryViewItemPath,
  inventoryAdjustItemPath,
  inventoryAdjustPackagePath,
  inventoryItemsPath,
  inventoryPackagesPath,
  inventoryTagsPath,
  inventoryCreateLocationPath,
  inventoryEditLocationPath,
  inventoryLocationsPath,
  inventoryItemsAvailabilityPath,
  inventoryPackagesAvailabilityPath,
  inventoryItemsAuditLogsPath,
  inventoryDownloadRequestsPath,
  inventoryGuestSummaryReportPath,
  inventoryDonorSummaryReportPath,
  inventoryLowStockItemsPath,
  inventoryOnHandPath
} from '../../../routes/Paths';

const NAV_KEYS = {
  DASHBOARD: 'dashboard-nav',
  ADD_SKU: 'add-sku-nav',
  ITEMS: 'items-nav',
  ITEMS_CREATE: 'items-create-nav',
  ITEMS_LIST: 'items-list-nav',
  ITEMS_AVAILABILITY: 'items-availability-nav',
  ITEMS_AUDIT_LOGS: 'items-audit-logs-nav',
  PACKAGES: 'packages-nav',
  PACKAGES_CREATE: 'packages-create-nav',
  PACKAGES_LIST: 'packages-list-nav',
  PACKAGES_AVAILABILITY: 'packages-availability-nav',
  TAGS: 'tags-nav',
  LOCATIONS: 'locations-nav',
  REPORTS: 'reports-nav',
  REPORTS_GUEST_SUMMARY: 'reports-guest-summary-nav',
  REPORTS_DONOR_SUMMARY: 'reports-donor-summary-nav',
  LOW_STOCK_ITEMS: 'low-stock-items-nav',
  ON_HAND: 'on-hand-nav',
  ITEMS_SKUS: 'item-skus',
  DOWNLOAD_REQUESTS: 'download-nav',
  IMPORT_NAV: 'import-nav',
  ITEMS_IMPORT: 'items-import-nav',
  ITEMS_QUANTITY_IMPORT: 'items-quantity-import-nav'
};

export const navKeysByPath = {
  [inventoryDashboardPath]: NAV_KEYS.DASHBOARD,
  [inventoryCreateItemPath]: NAV_KEYS.ITEMS_CREATE,
  [inventoryItemsPath]: NAV_KEYS.ITEMS_LIST,
  [inventoryEditItemPath]: NAV_KEYS.ITEMS_LIST,
  [inventoryViewItemPath]: NAV_KEYS.ITEMS_LIST,
  [inventoryAdjustItemPath]: NAV_KEYS.ITEMS_LIST,
  [inventoryItemsAvailabilityPath]: NAV_KEYS.ITEMS_AVAILABILITY,
  [inventoryItemsAuditLogsPath]: NAV_KEYS.ITEMS_AUDIT_LOGS,
  [inventoryCreatePackagePath]: NAV_KEYS.PACKAGES_CREATE,
  [inventoryPackagesPath]: NAV_KEYS.PACKAGES_LIST,
  [inventoryEditPackagePath]: NAV_KEYS.PACKAGES_LIST,
  [inventoryViewPackagePath]: NAV_KEYS.PACKAGES_LIST,
  [inventoryAdjustPackagePath]: NAV_KEYS.PACKAGES_LIST,
  [inventoryPackagesAvailabilityPath]: NAV_KEYS.PACKAGES_AVAILABILITY,
  [inventoryTagsPath]: NAV_KEYS.TAGS,
  [inventoryLocationsPath]: NAV_KEYS.LOCATIONS,
  [inventoryCreateLocationPath]: NAV_KEYS.LOCATIONS,
  [inventoryEditLocationPath]: NAV_KEYS.LOCATIONS,
  [inventoryDownloadRequestsPath]: NAV_KEYS.DOWNLOAD_REQUESTS,
  [inventoryGuestSummaryReportPath]: NAV_KEYS.REPORTS_GUEST_SUMMARY,
  [inventoryDonorSummaryReportPath]: NAV_KEYS.REPORTS_DONOR_SUMMARY,
  [inventoryLowStockItemsPath]: NAV_KEYS.LOW_STOCK_ITEMS,
  [inventoryOnHandPath]: NAV_KEYS.ON_HAND
};

export default NAV_KEYS;
